import logo from "./logo.svg";
import "./App.css";
import Home from "./pages/home/home";
import Preloader from "./components/preloader/Preloader";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import About from "./pages/about/about";
import Investment from "./pages/investment/Investment";
import Contact from "./pages/contactUs/contact";
import Faq from "./pages/Faq/faq";
import MyAccount from "./pages/My-Account/myAccount";
import MyProfile from "./pages/myProfile/MyProfile";
import ChangePassword from "./pages/changePassword/changePassword";
import ChangePin from "./pages/changePin/changePin";
import Register from "./auth/register/register";
import { useEffect, useState } from "react";
import { auth, firestore } from "./db/config";
import { useDispatch, useSelector } from "react-redux";
import Login from "./auth/login/login";
import Deposit from "./pages/makeDeposit/Deposit";
import ChoosePaymentType from "./pages/makeDeposit/choosePaymentType";
import DepositList from "./pages/depositList/depositList";
import PaymentRequest from "./pages/paymentRequest/paymentRequest";
import FundTransfer from "./pages/fundTransfer/fundTransfer";
import PageNotFound from "./pages/pgeNotFound/pageNotFound";
import FundtransferHistory from "./pages/fundTransferHistory/fundtransferHistory";
import Referral from "./pages/referrals/referral";
import ReferralList from "./pages/referralList/referralList";
import Chat from "./components/chat/chat";
import SoundComponent from "./components/chat/soundComponent";
import SupportButton from "./components/supportButton/SupportButton";
import AdminSigninCover from "./adminFolder/auth/signinCover";
import MessageCover from "./adminFolder/messageComponent/messageCover";

function App() {
  const dispatch = useDispatch();

  const userRandomNumber = useSelector((state) => state.userRandomNumber);
  const getUserNumber = userRandomNumber.userRandomNumber;
  const userRandomNumber1 = Math.ceil(
    Math.random() * 2000000050366329994 * Math.random() * Math.random()
  );
  const toggleReducer = useSelector((state) => state.toggleReducer);
  const toggle = toggleReducer.toggle;
  // console.log(toggle);
  if (getUserNumber === null) {
    dispatch({ type: "user_random_number", data: userRandomNumber1 });
  } else {
  }
  const unsubscribeUser = (data) => {
    dispatch({ type: "user_details", data });
  };
  const getuserRandomNumber = userRandomNumber.userRandomNumber;
  const modifyUserNumber = String(getuserRandomNumber);
  useEffect(() => {
    firestore
      .collection("customerMessages")
      .doc(modifyUserNumber)
      .collection("messages")
      .onSnapshot((snapShot) => {
        const getUnreadMessage = snapShot.docs.filter(
          (message) =>
            message.data().fromUser === "admin" && message.data().read === false
        );
        const getNewMessage = getUnreadMessage.map((newMessage) =>
          newMessage.data()
        );

        dispatch({ type: "unread_message", data: getNewMessage });
      });
    auth.onAuthStateChanged((user) => {
      if (user) {
        const lastLogin = auth.currentUser.metadata.lastSignInTime;
        const creationTime = auth.currentUser.metadata.creationTime;
        const getRef = firestore.collection("users").doc(user.uid).get();
        getRef.then((data) =>
          unsubscribeUser({ ...data.data(), lastLogin, creationTime })
        );
        firestore
          .collection("userPaymentDetails")
          .doc(user.uid)
          .get()
          .then((data) => {
            if (data.exists) {
              dispatch({
                type: "bank_details",
                data: { ...data.data(), userId: user.uid },
              });
            } else {
              dispatch({ type: "bank_details", data: false });
            }
          });
      } else {
        unsubscribeUser(null);
      }
    });
  }, unsubscribeUser(null));

  return (
    <BrowserRouter>
      <div className="App">
        <Preloader />

        <Switch>
          <Route exact path="/" component={Home}></Route>
          <Route path="/about" component={About}></Route>
          <Route path="/investment" component={Investment}></Route>
          <Route path="/contact" component={Contact}></Route>
          <Route path="/faq" component={Faq}></Route>
          <Route path="/my_account" component={MyAccount}></Route>
          <Route path="/profile" component={MyProfile}></Route>
          <Route path="/change_password" component={ChangePassword}></Route>
          <Route path="/change_pin" component={ChangePin}></Route>
          <Route path="/register" component={Register}></Route>

          <Route path="/login" component={Login}></Route>
          <Route path="/deposit" component={Deposit}></Route>
          <Route path="/deposit_list" component={DepositList}></Route>
          <Route path="/payment_request" component={PaymentRequest}></Route>
          <Route path="/transfer_fund" component={FundTransfer}></Route>
          <Route
            path="/fund_transfer_history"
            component={FundtransferHistory}
          ></Route>
          <Route path="/referrals" component={Referral}></Route>
          <Route path="/referral_list" component={ReferralList}></Route>
          <Route path="/adminPortal" component={AdminSigninCover}></Route>
          <Route path="/adminMessage" component={MessageCover}></Route>
          <Route component={PageNotFound}></Route>
        </Switch>
        {toggle === "none" ? <SupportButton /> : <Chat />}

        {/* <Footer /> */}
      </div>
    </BrowserRouter>
  );
}

export default App;
